import { render } from "./ChatMensajes.vue?vue&type=template&id=f036fc4a&scoped=true"
import script from "./ChatMensajes.vue?vue&type=script&lang=js"
export * from "./ChatMensajes.vue?vue&type=script&lang=js"

import "./ChatMensajes.vue?vue&type=style&index=0&id=f036fc4a&lang=css"
import "./ChatMensajes.vue?vue&type=style&index=1&id=f036fc4a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\reclasin-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f036fc4a"]])

export default __exports__